import { Severity } from '@/shared/types/severity';

export interface IgcSnackbarProps {
  severity?: Severity,
  message: string,
  hideTimeout?: number,
}

interface SnackbarController {
  show: (props: IgcSnackbarProps, snackbarParams?: any) => void,
  hide: () => void,

  setStyles: (customStyles: object) => void,
  resetStyles: () => void,
  getSeverity: () => Severity,
}

export class IgcSnackbarService {
  private snackbarController!: SnackbarController;

  public isShowing = false;

  registerComponent(snackbarController: SnackbarController) {
    this.snackbarController = snackbarController;
  }

  setStyles(customStyles: object) {
    this.snackbarController.setStyles(customStyles);
  }

  resetStyles() {
    this.snackbarController.resetStyles();
  }

  show(props: IgcSnackbarProps | string, snackbarParams?: any) {
    let snackbarProps;

    if (typeof props === 'string') {
      snackbarProps = {
        message: props,
      };
    } else {
      snackbarProps = props;
    }

    this.snackbarController.show(snackbarProps, snackbarParams);
    this.isShowing = true;
  }

  hide() {
    this.snackbarController.hide();
    this.isShowing = false;
  }

  info(message: string, snackbarParams?: any) {
    return this.show({
      severity: Severity.info,
      message,
    }, snackbarParams);
  }

  success(message: string, snackbarParams?: any) {
    return this.show({
      severity: Severity.success,
      message,
    }, snackbarParams);
  }

  warning(message: string, snackbarParams?: any) {
    return this.show({
      severity: Severity.warning,
      message,
    }, snackbarParams);
  }

  error(message: string, snackbarParams?: any) {
    return this.show({
      severity: Severity.error,
      message,
    }, snackbarParams);
  }

  getSeverity(): Severity {
    return this.snackbarController.getSeverity();
  }

  isError(): boolean {
    return this.getSeverity() === Severity.error;
  }
}
